// extracted by mini-css-extract-plugin
module.exports = {"primary":"#9BE3DE"};